import React, { useContext, useRef } from 'react';
import { ClickAwayListener, Grow, makeStyles, Paper, Popper } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
import hospitalIcon from '../../assets/images/logo/hospital-icon-side-bar-right.svg';
import sideRightStyles from '../SideBarRight/SideBarRight.styles';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import LanguageContext from '../../contexts/languageContext';

const styles = makeStyles({
    paper: {
        minWidth: '171px',
        borderRadius: '6px',
        display: 'flex',
        justifyContent: (props) => (props.rtl ? 'flex-start' : 'flex-end'),
        padding: '20px 10px 17px 26px',
        direction: ({ rtl }) => (rtl ? 'rtl' : 'ltr'),
        maxHeight: '300px',
        overflow: 'auto'
    },
    title: {
        fontSize: '15px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.69',
        letterSpacing: 'normal',
        textAlign: (props) => (props.rtl ? 'right' : ' left'),
        color: '#232733',
        margin: '0 11px'
    },
    btn: {
        minWidth: '110px',
        fontSize: '13px',
        color: '#fff',
        whiteSpace: 'nowrap',
        backgroundColor: 'rgba(22 118 204 / 70%)',
        marginLeft: '16px',
        borderRadius: '6px',
        height: '36px'
    },
    btnLabel: {
        justifyContent: 'space-between',
        flexFlow: 'row wrap'
    },
    clinicText: {
        padding: '0 10px'
    },
    menuIcon: {
        margin: '0 4px'
    },
    optionContainer: {},
    optionHeader: {
        color: '#aaa',
        padding: '6px 1em 3px',
        fontWeight: 'bold'
    },
    optionItem: {
        padding: '6px 1em',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#e3e3e3'
        },
        '&:last-child': {
            borderRadius: '6px'
        }
    },
    radioGroup: {
        direction: ({ rtl }) => (rtl ? 'rtl' : 'ltr')
    }
});
function ClinicRadioSelect({ polyclinics, handleChangeClinic, toggleMenu, menuOpened }) {
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const anchorRef = useRef(null);
    const classesSideRight = sideRightStyles();
    const workspace = useSelector((state) => state?.user?.workspace?.clinic);

    return (
        <>
            <div
                className={classesSideRight.img}
                onClick={toggleMenu}
                ref={anchorRef}
                data-testid="hospital"
            >
                <img src={hospitalIcon} />
                <Popper
                    style={{ zIndex: 1900 }}
                    open={menuOpened}
                    anchorEl={anchorRef.current}
                    placement="left-end"
                    role={undefined}
                    transition
                    disablePortal={false}
                    data-testid="selectionClinic"
                >
                    {({ TransitionProps }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: 'right bottom'
                            }}
                        >
                            <Paper className={classes.paper}>
                                <ClickAwayListener onClickAway={() => toggleMenu(false)}>
                                    <div className={classes.optionsContainer}>
                                        <FormControl component="fieldset">
                                            {polyclinics?.map((polyclinic) => (
                                                <div
                                                    className={classes.optionContainer}
                                                    key={polyclinic.id}
                                                >
                                                    <div className={classes.title}>
                                                        {polyclinic.name}
                                                    </div>

                                                    <div>
                                                        {polyclinic.clinics.map((clinic) => (
                                                            <RadioGroup
                                                                classes={{
                                                                    root: classes.radioGroup
                                                                }}
                                                                aria-label="polyclinic"
                                                                name="polyclinic"
                                                                value={workspace?.name}
                                                                key={clinic.id}
                                                                onChange={() =>
                                                                    handleChangeClinic(
                                                                        clinic,
                                                                        polyclinic
                                                                    )
                                                                }
                                                            >
                                                                <FormControlLabel
                                                                    value={clinic.name}
                                                                    control={
                                                                        <Radio
                                                                            inputProps={{
                                                                                'data-testid': `${clinic.name}`
                                                                            }}
                                                                        />
                                                                    }
                                                                    label={clinic.name}
                                                                    style={{ marginLeft: '0' }}
                                                                />
                                                            </RadioGroup>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </FormControl>
                                    </div>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
        </>
    );
}

ClinicRadioSelect.propTypes = {
    polyclinics: PropTypes.array,
    handleChangeClinic: PropTypes.func,
    toggleMenu: PropTypes.func,
    menuOpened: PropTypes.bool
};
export default ClinicRadioSelect;
